export default "https://cdn.questicon.mathletics.com/assets/images/activity-guide-270ff654c740c43c29234825b7cc7b2e.svg";